import { createAction, createSlice } from '@reduxjs/toolkit';
import { fetchLeaderboardOverview } from '@/services/leaderboards/leaderboard-thunks';
import {
  Leaderboard,
  LeaderboardDetails,
  LeaderboardOverview,
  LeaderboardType,
  PayoutStructure,
} from '@repo/common-types';

export interface LeaderboardsState {
  leaderboardOverview: Partial<LeaderboardOverview> | null;
}

const initialState: LeaderboardsState = {
  leaderboardOverview: null,
};

export const updateLeaderboardOverview = createAction<Partial<Leaderboard>>('leaderboards/updateLeaderboardOverview');
export const updateLeaderboardOverviewSuccess = createAction<Partial<Leaderboard>>(
  'leaderboards/updateLeaderboardOverviewSuccess',
);

export const leaderboardsSlice = createSlice({
  name: 'leaderboards',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLeaderboardOverview.fulfilled, (state, action) => {
      state.leaderboardOverview = action.payload || null;
    });
    builder.addCase(updateLeaderboardOverview, (state, action) => {
      const overview =
        state.leaderboardOverview?.[action.payload.type as LeaderboardType] ?? ({} as Partial<LeaderboardDetails>);

      if (action.payload.minRakeQualifierAmount) {
        overview.minRakeQualifierAmount = action.payload.minRakeQualifierAmount;
      }
      if (action.payload.minReseedAmount) {
        overview.minReseedAmount = action.payload.minReseedAmount;
      }
      if (action.payload.reseedPercentage) {
        overview.reseedPercentage = action.payload.reseedPercentage;
      }

      state.leaderboardOverview = {
        ...state.leaderboardOverview,
        [action.payload.type as LeaderboardType]: overview,
      };
    });
    builder.addCase(updateLeaderboardOverviewSuccess, (state, action) => {
      state.leaderboardOverview = {
        ...state.leaderboardOverview,
        [action.payload.type as LeaderboardType]: action.payload,
      };
    });
  },
});

export default leaderboardsSlice.reducer;
